import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-assgin",
  "use": "icon-assgin-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"icon-assgin\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.809.412a1 1 0 1 0-1.618 1.176L17.036 5.5H2a1 1 0 0 0 0 2h15.036c1.635 0 2.58-1.854 1.618-3.176L15.809.412ZM4.19 17.088a1 1 0 0 0 1.618-1.176L2.964 12H18a1 1 0 1 0 0-2H2.964c-1.635 0-2.58 1.854-1.618 3.176l2.845 3.912Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol